import { DocumentationItemHeaderV1 } from "@supernova-studio/model";
import { z } from "zod";

const DocumentationColorV1 = z.object({
  aliasTo: z.string().optional(),
  value: z.string().optional(),
});

const DTODocumentationItemHeaderV1 = DocumentationItemHeaderV1.omit({
  foregroundColor: true,
  backgroundColor: true,
}).extend({
  foregroundColor: DocumentationColorV1.optional(),
  backgroundColor: DocumentationColorV1.optional(),
});

export const DTODocumentationItemConfigurationV1 = z.object({
  showSidebar: z.boolean(),
  isPrivate: z.boolean(),
  isHidden: z.boolean(),
  header: DTODocumentationItemHeaderV1,
});

export type DTODocumentationItemConfigurationV1 = z.infer<typeof DTODocumentationItemConfigurationV1>;
